export default "__VITE_ASSET__8mJmNoPp__"